module.exports = __webpack_public_path__ + "static/media/point_icon_05.f201feab.svg";